class TimephoriaLoyaltyTabs extends HTMLElement {
  connectedCallback() {
    this.buttons = Array.from(this.querySelectorAll('[role="tab"]'));
    this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));

    this.buttons.forEach((button) => {
      button.addEventListener('click', () => this.select(button));
    });
  }

  select(activeButton) {
    const activePanelId = activeButton.getAttribute('data-panel');

    this.buttons.forEach((button) => {
      const isActive = button === activeButton;
      button.classList.toggle('is-active', isActive);
      button.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });

    this.panels.forEach((panel) => {
      panel.hidden = panel.id !== activePanelId;
    });
  }
}

if (!window.customElements.get('timephoria-loyalty-tabs')) {
  window.customElements.define('timephoria-loyalty-tabs', TimephoriaLoyaltyTabs);
}

class TimephoriaLoyaltyReferral extends HTMLElement {
  connectedCallback() {
    this.button = this.querySelector('[data-tp-loyalty-open-rewards]');

    if (!this.button) return;

    this.button.addEventListener('click', () => this.openRewards());
  }

  openRewards() {
    const hubAction = document.querySelector('[data-tp-floating-hub-action="points"]');

    if (hubAction) {
      hubAction.click();
      return;
    }

    if (window.SmileUI && typeof window.SmileUI.openPanel === 'function') {
      window.SmileUI.openPanel();
      return;
    }

    window.location.hash = 'smile-home';

    let attempts = 0;
    const smileTimer = window.setInterval(() => {
      attempts += 1;

      if (window.SmileUI && typeof window.SmileUI.openPanel === 'function') {
        window.clearInterval(smileTimer);
        window.SmileUI.openPanel();
      } else if (attempts >= 40) {
        window.clearInterval(smileTimer);
      }
    }, 250);
  }
}

if (!window.customElements.get('timephoria-loyalty-referral')) {
  window.customElements.define('timephoria-loyalty-referral', TimephoriaLoyaltyReferral);
}
